<template>
    <div class="form-group">
        <label class="control-label" for="JourneyName">{{resource('JourneyBuilderPublishModel_Name_DisplayName')}}</label>
        <input class="form-control" 
               data-val="true" 
               data-val-required="Het veld naam is verplicht" 
               id="JourneyName" 
               name="JourneyName" 
               type="text"
               
               :disabled="!canWrite"
               v-model="journeyNameModel"
        >

        <template v-if="$v.journeyNameModel.$dirty && $v.journeyNameModel.$invalid">
            <required-error-message v-if="!$v.journeyNameModel.required" :field-name="resource('JourneyBuilderPublishModel_Name_DisplayName')" />
            <max-length-error-message v-if="!$v.journeyNameModel.maxLength" :field-name="resource('JourneyBuilderPublishModel_Name_DisplayName')" :max-length="255" />
            
            <br />
        </template>

        <br />
        <toggle-button :value="journeyIsActive"
                @change="$emit('update:journeyIsActive', $event.value)"
                :sync="true"
                :labels="{checked: resource('Bool_Active'), unchecked: resource('Bool_Inactive')}"
                :width="78"
        />
        <br />

        <label class="control-label" for="JourneyWorld">{{resource('JourneyBuilderPublishModel_World_DisplayName')}}</label>
         <v-select v-if="journeyWorlds.length > 0" class='form-control'
                v-model="worldModel"
                :options="journeyWorlds"
                label="name"
                :clearable="true"
                searchable
                filterable
                taggable

                close-on-select
            >
                <div slot='no-options' />
        </v-select>

        <br />
        <label class="control-label" for="journey-division-dropdown">{{resource('JourneyBuilderPublishModel_DivisionId_DisplayName')}}</label>
        
        <template v-if="divisionList">
            <division-dropdown
                    v-model="journeyDivisionIdModel"
                    v-bind:division-list="divisionList"
                    
                    id="journey-division-dropdown"
                    :disabled="!canWrite"
            ></division-dropdown>
        </template>
        <template v-else>
            <!-- Placeholder -->
            <select class="form-control" />
        </template>
        
        <br />
        
        <label class="control-label" for="JourneyStartDate">{{resource('JourneyBuilderPublishModel_StartDate_DisplayName')}}</label>
        <datepicker
                id="JourneyStartDate"
                name="JourneyStartDate"
                :value="startDate"
                @input="updateStartDate"

                :options="startDatePickerOptions"
        >
        </datepicker>

        <label class="control-label" for="JourneyEndDate">{{resource('JourneyBuilderPublishModel_EndDate_DisplayName')}}</label>
        <datepicker
                id="JourneyEndDate"
                name="JourneyEndDate"

                :value="endDate"
                @input="updateEndDate"

                :options="endDatePickerOptions"
        >
        </datepicker>
        
        <label class="control-label" for="JourneyDescription">{{resource('JourneyBuilderPublishModel_Description_DisplayName')}}</label>
        <textarea 
                rows="7" 
                class="form-control"  
                id="JourneyDescription"

                :disabled="!canWrite"
                :value="journeyDescription" 
                @change="$emit('update:journeyDescription', $event.target.value)"
        />
    </div>
</template>

<script>
    import {required, maxLength} from 'vuelidate/lib/validators';
    
    import {validationMixin} from 'vuelidate';
    import resources from "../../../../Util/Mixins/resources";
    import permissionsMixin from '../../Mixins/journey-permissions';
    import dateHelpers from '../../Util/date-helpers';

    import VSelect from 'vue-select';
    import Datepicker from "../../../../Components/Util/DatePicker.vue";
    import DivisionDropdown from "../../../../Components/Util/DivisionDropdown";
    import RequiredErrorMessage from "../../../../Components/Errors/RequiredErrorMessage.vue";
    import MaxLengthErrorMessage from "../../../../Components/Errors/MaxLengthErrorMessage.vue";
    import { ToggleButton } from 'vue-js-toggle-button';

    import api from '../../api';
    import divisionApi from "../../../../Api/divisions";
    import {bootstrapDangerGrowl} from "../../../../Util/growler";

    export default {
        name: 'journey-builder-menu-edit-form',
        components: {
            Datepicker,
            DivisionDropdown,
            RequiredErrorMessage,
            MaxLengthErrorMessage,
            VSelect,
            ToggleButton
        },
        mixins: [resources, permissionsMixin, validationMixin],
        validations: {
            journeyNameModel: {
                required,
                maxLength: maxLength(255)
            }
        },
        created() {
            divisionApi.getDivisionsList({ includeDisabled: true })
                .then(divisions => this.divisionList = divisions, bootstrapDangerGrowl);
            
            api.getWorlds().then(
                (worlds) => { 
                    this.journeyWorlds = worlds; 
                },
                bootstrapDangerGrowl
            );
        },
        computed: {
            journeyNameModel: {
                get(){
                    return this.journeyName;
                },
                set(value){
                    this.$v.journeyNameModel.$touch();
                    this.$emit('update:journeyName', value);
                }
            },
            worldModel: {
                get() {
                    return this.journeyWorlds.find((world) => world.id === this.journeyWorld);
                },
                set(value) {
                    this.$emit('update:journeyWorld', value != null ? value.id : null);
                }
            },
            journeyDivisionIdModel: {
                get(){
                    return this.journeyDivisionId;
                },
                set(value){
                    this.$emit('update:journeyDivisionId', value);
                }
            },
            startDate(){
                return this.journeyStartDate ? dateHelpers.getDateFromString(this.journeyStartDate) : undefined;
            },
            endDate(){
                return this.journeyEndDate ? dateHelpers.getDateFromString(this.journeyEndDate) : undefined;
            },
            
            startDatePickerOptions(){
                return {
                    clearButton: this.canWrite,
                    disabled: !this.canWrite,
                    required: false,
                    typeable: false,
                    
                    disabledDates: {
                        from: undefined,
                        to: new Date(0)
                    }
                };
            },
            endDatePickerOptions(){
                return {
                    clearButton: this.canWrite,
                    disabled: !this.canWrite,
                    required: false,
                    typeable: false,

                    disabledDates: {
                        from: undefined,
                        to: this.startDate || new Date(0)
                    }
                };
            }
        },
        methods: {
            updateStartDate(date){
                //EndDate always has to be equal; or greater than our startDate
                if(date > this.endDate){
                    this.updateEndDate(undefined);
                }
                
                this.emitDateChange('update:journeyStartDate', date);
            },
            updateEndDate(date){
                this.emitDateChange('update:journeyEndDate', date);
            },
            emitDateChange(event, date){
                if(date){
                    date = dateHelpers.getStringifiedDate(date);
                }

                this.$emit(event, date);
            }
        },
        data() {
            return {
                journeyWorlds: [],
                divisionList: undefined
            }
        },
        props: {
            journeyName: String,
            journeyDescription: String,
            journeyStartDate: String,
            journeyEndDate: String,
            journeyWorld: String,
            journeyIsActive: Boolean,
            journeyDivisionId: String
        }
    }
</script>